import { Box } from "@mui/material"
import { useParams } from "@tanstack/react-router"
import type { ReactElement } from "react"
import RegistrationArea from "screens/CompanySettings/Registration/components/CompanyRegistrationArea"

import { COMPANY_EDIT_ROUTE } from "@/screens/Companies/constants"
import LegalInfoArea from "@/screens/CompanySettings/Registration/components/LegalInfoArea"

const RegistrationContainer = (): ReactElement => {
  const { companyId } = useParams({ from: COMPANY_EDIT_ROUTE })
  return (
    <Box className='flex h-full flex-col space-y-4'>
      <LegalInfoArea companyId={companyId} />
      <RegistrationArea companyId={companyId} />
    </Box>
  )
}

export default RegistrationContainer
